// Copyright 2026. WebPros International GmbH. All rights reserved.

import { RootState } from 'admin/core/store';

export const selectHasMoreUnreads = (state: RootState) =>
    state.notification.list.meta.total > state.notification.list.meta.to;
